module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"icon":"src/images/vera-green.svg","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"19139ae414295806db631908aa966067"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
